<!--  -->
<template>
  <div class="lisnewk">
    <div class="werww">
      <div class="search_box">
        <el-select
          v-model="objr.platform_id"
          style="margin-right:5px"
          class="launch"
          filterable
          placeholder="选择平台"
        >
          <el-option
            v-for="item in platforms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-input v-model="objr.link_template_no" style="width:200px;margin-right:5px" placeholder="请输入模板编号" />
        <el-input v-model="objr.book_name" style="width:200px;margin-right:5px" placeholder="请输入书名" />
        <el-select v-model="objr.promotion_type" placeholder="请选择推广类型">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="serach">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reset">重置</el-button>
      </div>
      <div class="addlinkbox">
        <el-button type="success" icon="el-icon-plus" @click="add">新增推广链接</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="book_platform_name"
        label="平台名"
        width="150"
        align="center"
      />
      <el-table-column
        prop="link_template_no"
        label="模板编号"
        width="250"
        align="center"
      />
      <el-table-column
        prop="book_name"
        label="书名"
        width="180"
        align="center"
      />
      <el-table-column
        prop="chapter_name"
        label="章节名"
        width="180"
        align="center"
      />
      <el-table-column
        prop="book_id"
        label="书籍id"
        width="180"
        align="center"
      />
      <el-table-column
        prop="chapter_id"
        label="章节id"
        width="180"
        align="center"
      />
      <el-table-column
        prop="promotion_type_text"
        label="推广类型"
        width="150"
        align="center"
      />
      <el-table-column
        prop="admin_name"
        label="管理员"
        width="100"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="150"
        align="center"
      />
      <el-table-column
        prop="book_platform_name"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="delrte(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
    <el-dialog
      title="推广链接"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <extensionlinkdialog @updata="updata" />
    </el-dialog>
  </div>
</template>

<script>
import extensionlinkdialog from './components/extensionlinkdialog.vue'
import { promotionlinktemplate, delbookPlatformcreate, strategyPlatformtwo } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { extensionlinkdialog, PaginationRight },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        page_size: 10,
        platform_id: null,
        link_template_no: null,
        book_name: null,
        promotion_type: null
      },
      total: null,
      tableData: [],
      platforms: [],
      options: [{
        value: 1,
        label: '内推'
      }, {
        value: 2,
        label: '外推'
      }]
    }
  },
  created() {
    this.serlist()
    this.strategylist()
  },
  mounted() {

  },
  methods: {
    // 获取策略列表
    async strategylist() {
      const data = await strategyPlatformtwo()
      this.platforms = data.data.list
      console.log('data', data)
    },
    async serlist() {
      const data = await promotionlinktemplate(this.objr)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    add() {
      this.dialogVisible = true
    },
    updata() {
    // 更新列表
      this.dialogVisible = false
      this.serlist()
    },
    fetchPageSizeone(e) {
      this.objr.page_size = e
      this.serlist()
    },
    fetchCurrentPageone(e) {
      this.objr.page = e
      this.serlist()
    },
    delrte(id) {
      console.log('id', id)
      this.$confirm('确定删除次项吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        delbookPlatformcreate({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.serlist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    serach() {
      this.objr.page = 1
      this.serlist()
    },
    reset() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.objr.platform_id = null
      this.objr.link_template_no = null
      this.objr.book_name = null
      this.objr.promotion_type = null
      this.serlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.lisnewk{
  padding: 20px;
}
.addlinkbox{
  text-align: right;
  /* margin-bottom: 10px; */
}
.werww{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>
